import C7Init from "./commerce7/c7";
import Modules from "./modules/modules";

new C7Init().init();
new Modules().init();

jQuery(document).ready(function ($) {
  //   jQuery(".mobile-hamburger").on("click", function () {
  //     jQuery(".mobile-side-menu").toggleClass("opened");
  //     jQuery(".menu-outside").toggleClass("d-none");
  //     jQuery("body").toggleClass("scroll-disabled");
  //   });
  //   jQuery(".menu-outside, .hide-mobile-menu").on("click", function () {
  //     jQuery(".mobile-side-menu").toggleClass("opened");
  //     jQuery(".menu-outside").toggleClass("d-none");
  //     jQuery("body").toggleClass("scroll-disabled");
  //   });

  const checkFooter = () => {
    const windowHeight = jQuery(window).height();
    const contentHeight = jQuery("body").height();
    const footerHeight = jQuery("footer").height();

    if (jQuery("footer").hasClass("sticky")) {
      if (windowHeight < contentHeight + footerHeight) {
        jQuery("footer").removeClass("sticky");
      }
    } else {
      if (windowHeight > contentHeight) {
        jQuery("footer").addClass("sticky");
      }
    }
  };

  if (jQuery("#c7-content").length == 0) {
    checkFooter();
  }

  jQuery(window).resize(function () {
    checkFooter();
  });

  jQuery("ul#menu-footer-nav > li").click(function () {
    let open = jQuery(this).hasClass("open");
    jQuery("ul#menu-footer-nav > li").removeClass("open");
    if (!open) {
      jQuery(this).addClass("open");
    }
  });
  
  if ($(".product-drop").length > 0) {
    var endDate = new Date($(".product-drop").data("end"));
    var startDate = new Date($(".product-drop").data("start"));
    var now = new Date();
    if (now.getTime() < startDate.getTime()) {
      $(".product-drop-now-available").hide();
      $(".product-drop-sold-out").hide();
    } else if (now.getTime() > endDate.getTime()) {
      $(".product-drop-now-available").hide();
      $(".product-drop-coming-soon").hide();
    } else {
      $(".product-drop-coming-soon").hide();
      $(".product-drop-sold-out").hide();
      var x = setInterval(function () {
        var dateNow = new Date();
        var distance = endDate.getTime() - dateNow.getTime();
        if (distance < 0) {
          $(".product-drop-now-available .section-products .product-item").each(
            function () {
              $(this)
                .find(".c7-buy-product .c7-product__add-to-cart button")
                .attr("disabled", true);
            }
          );
        }
      }, 1000);
    }
  }
  $(".btn-test-atc").click(function () {
    const id = $(this).closest(".product-item").data("id");
    const variant = $(this).closest(".product-item").data("variants");
    $.ajax({
      type: "POST",
      dataType: "json",
      url: theme_object.ajax_url,
      data: {
        action: "add_to_cart",
        productId: id,
        quantity: 2,
        variantId: variant,
        note: "This is a note about the product",
      },
      success: function (response) {
        console.log(response);
      },
    });
  });
});
